<div class="d-flex flex-column align-items-center px-2 py-3 gap-1 h-100">
    @for (navGroup of navState.navGroups; track navGroup.id; let isLast = $last) {
        <div
            ngbDropdown
            fscHoverDropdown
            [openDelay]="400"
            [closeDelay]="400"
            [autoClose]="false"
            [allowAutoClose]="!anyPopoverOpen"
            [placement]="isLast ? 'right-bottom' : 'right-top'"
            [ngClass]="isLast ? 'mt-auto' : ''">

            @if (navGroup.link !== undefined) {
                @if (!navGroup.isExternalLink) {
                    <!-- Internal link -->
                    <a
                        ngbDropdownToggle
                        [routerLink]="navGroup.link"
                        class="btn btn-ghost d-flex align-items-center justify-content-center"
                        [ngClass]="[getNavGroupClass(navGroup.id), isLast ? 'mt-auto' : '']">
                        <ng-container [ngTemplateOutlet]="dropdownMenu"></ng-container>
                    </a>
                } @else {
                    <!-- External link -->
                    <a
                        ngbDropdownToggle
                        [href]="navGroup.link[0]"
                        target="_blank"
                        rel="noopener"
                        referrerpolicy="no-referrer"
                        [ngClass]="[ getNavGroupClass(navGroup.id), isLast ? 'mt-auto' : '']"
                        class="btn btn-ghost d-flex align-items-center justify-content-center">
                        <ng-container [ngTemplateOutlet]="dropdownMenu"></ng-container>
                    </a>
                }
            } @else {
                <button
                    type="button"
                    [ngClass]="[ getNavGroupClass(navGroup.id), isLast ? 'mt-auto' : '']"
                    class="btn btn-ghost d-flex align-items-center justify-content-center"
                    (click)="navGroup.onClick()">
                    <ng-container [ngTemplateOutlet]="dropdownMenu"></ng-container>
                </button>
            }

            <!-- Dropdown menu -->
            <ng-template #dropdownMenu>
                <fa-icon
                    [icon]="navGroup.icon"
                    [ngClass]="{'text-secondary': !isNavGroupSelected(navGroup.id), 'text-primary-500': isNavGroupSelected(navGroup.id) }"
                    class="no-margin"/>
                <div
                    ngbDropdownMenu
                    class="ms-1 rounded-3">
                    <!-- Include nav group in dropdown -->
                    @if (navGroup.link !== undefined) {
                        @if (navGroup.isExternalLink) {
                            <button
                                ngbDropdownItem
                                type="button"
                                (click)="externalNavClick(navGroup.link)"
                                class="d-flex justify-content-between">
                                <span>{{navGroup.label}}</span>
                                <fa-icon
                                    class="no-margin"
                                    [icon]="faArrowUpRightFromSquare"/>
                            </button>
                        } @else {
                            <button
                                ngbDropdownItem
                                type="button"
                                (click)="navClick(navGroup.link)"
                                class="d-flex position-relative"
                                [ngClass]="getDropdownClasses(navGroup.id, true)">
                                <span>{{navGroup.label}}</span>
                            </button>
                        }
                    } @else {
                        <button
                            ngbDropdownItem
                            type="button"
                            class="border-0"
                            [ngClass]="getDropdownClasses(navGroup.id, true)"
                            (click)="navGroup.onClick()">
                            <span>{{navGroup.label}}</span>
                        </button>
                    }

                    <!-- Sub nav dropdown items  -->
                    @for (subNav of navGroup.children; track subNav.id) {
                        @if (subNav.link !== undefined) {

                            @let upgradeTier = subNav.showUpgradeBadge ? subNav.showUpgradeBadge() : false;

                            @if (subNav.isExternalLink) {
                                <!-- External sub nav link-->
                                <button
                                    ngbDropdownItem
                                    type="button"
                                    (click)="externalNavClick(subNav.link)"
                                    class="d-flex justify-content-between">
                                    <span>{{subNav.label}}</span>
                                    <fa-icon
                                        class="no-margin"
                                        [icon]="faArrowUpRightFromSquare"/>
                                </button>
                            } @else if (upgradeTier) {
                                <button
                                    ngbDropdownItem
                                    #upgradeButton
                                    type="button"
                                    class="d-flex gap-2 justify-content-between align-items-center"
                                    (click)="upgradePopover.invokePopover()"
                                    [class.active]="upgradePopover.isPopoverOpen">
                                    <span>{{subNav.label}}</span>
                                    <fdx-surface-tier-icon-button
                                        [clickable]="false"
                                        [tier]="upgradeTier"
                                        size="sm"/>
                                </button>
                                <fdx-surface-upgrade-popover
                                    #upgradePopover
                                    [target]="upgradeButton"
                                    [feature]="subNav.upgradeFeature"
                                    [tier]="upgradeTier"
                                    placement="end"/>
                            } @else {
                                <!-- Internal sub nav link-->
                                <button
                                    ngbDropdownItem
                                    type="button"
                                    (click)="navClick(subNav.link)"
                                    class="d-flex position-relative"
                                    [ngClass]="getDropdownClasses(subNav.id, false)">
                                    <span>{{subNav.label}}</span>
                                </button>
                            }
                        } @else {
                            <button
                                ngbDropdownItem
                                type="button"
                                class="border-0"
                                [ngClass]="getDropdownClasses(subNav.id, false)"
                                (click)="subNav.onClick()">
                                <span>{{subNav.label}}</span>
                            </button>
                        }
                    }
                </div>
            </ng-template>
        </div>
    }
</div>
